import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import sicon1 from "../../icons/icon_google.svg";
import appleIcon from "../../icons/Apple_icon.png";
import coinIcon from "../../images/site_logo/TC-Logo-icon.png";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./style.css";
import { API_URL } from "../../constant";
import {
  FaUsers,
  FaArrowRight,
  FaEye,
  FaEyeSlash,
  FaLink,
  FaCopy,
  FaSearch,
  FaTimes,
  FaChevronDown,
  FaMapMarkerAlt,
  FaUsers as FaUsersIcon,
  FaGlobe,
  FaCheckCircle,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { debounce } from "lodash";
import QRCode from "react-qr-code";
const regionOptions = {
  // Africa
  Afghanistan: ["Asia"],  
  Albania: ["Europe"],
  Algeria: ["Africa"],
  Andorra: ["Europe"],
  Angola: ["Africa"],
  Argentina: ["South America"],
  Armenia: ["Asia"],
  Australia: ["Oceania"],
  Austria: ["Europe"],
  Azerbaijan: ["Asia"],
  Bahamas: ["North America"],
  Bahrain: ["Asia"],
  Bangladesh: ["Asia"],
  Barbados: ["North America"],
  Belarus: ["Europe"],
  Belgium: ["Europe"],
  Belize: ["North America"],
  Benin: ["Africa"],
  Bhutan: ["Asia"],
  Bolivia: ["South America"],
  "Bosnia and Herzegovina": ["Europe"],
  Botswana: ["Africa"],
  Brazil: ["South America"],
  Brunei: ["Asia"],
  Bulgaria: ["Europe"],
  "Burkina Faso": ["Africa"],
  Burundi: ["Africa"],
  Cambodia: ["Asia"],
  Cameroon: ["Africa"],
  Canada: ["Alberta", "British Columbia", "Manitoba", "Ontario", "Quebec"],
  "Cape Verde": ["Africa"],
  "Central African Republic": ["Africa"],
  Chad: ["Africa"],
  Chile: ["South America"],
  China: ["Asia"],
  Colombia: ["South America"],
  Comoros: ["Africa"],
  Congo: ["Africa"],
  "Costa Rica": ["North America"],
  Croatia: ["Europe"],
  Cuba: ["North America"],
  Cyprus: ["Europe"],
  "Czech Republic": ["Europe"],
  Denmark: ["Europe"],
  Djibouti: ["Africa"],
  "Dominican Republic": ["North America"],
  Ecuador: ["South America"],
  Egypt: ["Africa"],
  "El Salvador": ["North America"],
  Estonia: ["Europe"],
  Ethiopia: ["Africa"],
  Finland: ["Europe"],
  France: ["Europe"],
  Germany: ["Europe"],
  Ghana: ["Africa"],
  Greece: ["Europe"],
  Guatemala: ["North America"],
  Haiti: ["North America"],
  Honduras: ["North America"],
  Hungary: ["Europe"],
  Iceland: ["Europe"],
  India: [
    "Andhra Pradesh",
    "Delhi",
    "Karnataka",
    "Maharashtra",
    "Tamil Nadu",
    "West Bengal",
  ],
  Indonesia: ["Asia"],
  Iran: ["Tehran", "Isfahan", "Fars", "Mazandaran", "Khorasan Razavi"],
  Iraq: ["Asia"],
  Ireland: ["Europe"],
  Israel: ["Asia"],
  Italy: ["Europe"],
  Jamaica: ["North America"],
  Japan: ["Asia"],
  Jordan: ["Asia"],
  Kazakhstan: ["Asia"],
  Kenya: ["Africa"],
  Kuwait: ["Asia"],
  Kyrgyzstan: ["Asia"],
  Laos: ["Asia"],
  Latvia: ["Europe"],
  Lebanon: ["Asia"],
  Lesotho: ["Africa"],
  Liberia: ["Africa"],
  Libya: ["Africa"],
  Lithuania: ["Europe"],
  Luxembourg: ["Europe"],
  Madagascar: ["Africa"],
  Malawi: ["Africa"],
  Malaysia: ["Asia"],
  Maldives: ["Asia"],
  Mali: ["Africa"],
  Malta: ["Europe"],
  Mexico: ["North America"],
  Moldova: ["Europe"],
  Mongolia: ["Asia"],
  Morocco: ["Africa"],
  Mozambique: ["Africa"],
  Myanmar: ["Asia"],
  Namibia: ["Africa"],
  Nepal: ["Asia"],
  Netherlands: ["Europe"],
  "New Zealand": ["Oceania"],
  Nicaragua: ["North America"],
  Niger: ["Africa"],
  Nigeria: ["Africa"],
  "North Korea": ["Asia"],
  Norway: ["Europe"],
  Oman: ["Asia"],
  Pakistan: ["Asia"],
  Panama: ["North America"],
  Paraguay: ["South America"],
  Peru: ["South America"],
  Philippines: ["Asia"],
  Poland: ["Europe"],
  Portugal: ["Europe"],
  Qatar: ["Asia"],
  Romania: ["Europe"],
  Russia: ["Europe"],
  Rwanda: ["Africa"],
  "Saudi Arabia": ["Asia"],
  Senegal: ["Africa"],
  Serbia: ["Europe"],
  Singapore: ["Asia"],
  Slovakia: ["Europe"],
  Slovenia: ["Europe"],
  Somalia: ["Africa"],
  "South Africa": ["Africa"],
  "South Korea": ["Asia"],
  Spain: ["Europe"],
  "Sri Lanka": [
    "Central Province",
    "Eastern Province",
    "Northern Province",
    "Southern Province",
    "Western Province",
    "North Central Province",
    "North Western Province",
    "Sabaragamuwa Province",
    "Uva Province",
  ],
  Sudan: ["Africa"],
  Sweden: ["Europe"],
  Switzerland: ["Europe"],
  Syria: ["Asia"],
  Taiwan: ["Asia"],
  Tanzania: ["Africa"],
  Thailand: ["Asia"],
  Tunisia: ["Africa"],
  Turkey: ["Asia"],
  Uganda: ["Africa"],
  Ukraine: ["Europe"],
  "United Arab Emirates": ["Asia"],
  "United Kingdom": [
    "England - Bedfordshire",
    "England - Berkshire",
    "England - Bristol",
    "England - Buckinghamshire",
    "England - Cambridgeshire",
    "England - Cheshire",
    "England - City of London",
    "England - Cornwall",
    "England - Cumbria",
    "England - Derbyshire",
    "England - Devon",
    "England - Dorset",
    "England - Durham",
    "England - East Riding of Yorkshire",
    "England - East Sussex",
    "England - Essex",
    "England - Gloucestershire",
    "England - Greater London",
    "England - Greater Manchester",
    "England - Hampshire",
    "England - Herefordshire",
    "England - Hertfordshire",
    "England - Isle of Wight",
    "England - Kent",
    "England - Lancashire",
    "England - Leicestershire",
    "England - Lincolnshire",
    "England - Merseyside",
    "England - Norfolk",
    "England - North Yorkshire",
    "England - Northamptonshire",
    "England - Northumberland",
    "England - Nottinghamshire",
    "England - Oxfordshire",
    "England - Rutland",
    "England - Shropshire",
    "England - Somerset",
    "England - South Yorkshire",
    "England - Staffordshire",
    "England - Suffolk",
    "England - Surrey",
    "England - Sussex",
    "England - Tyne & Wear",
    "England - Warwickshire",
    "England - West Midlands",
    "England - West Sussex",
    "England - West Yorkshire",
    "England - Wiltshire",
    "England - Worcestershire",
    "Northern Ireland - Antrim",
    "Northern Ireland - Armagh",
    "Northern Ireland - Down",
    "Northern Ireland - Fermanagh",
    "Northern Ireland - Londonderry",
    "Northern Ireland - Tyrone",
    "Scotland - City of Aberdeen",
    "Scotland - Aberdeenshire",
    "Scotland - Angus",
    "Scotland - Argyll",
    "Scotland - Ayrshire",
    "Scotland - Banffshire",
    "Scotland - Berwickshire",
    "Scotland - Bute",
    "Scotland - Caithness",
    "Scotland - Clackmannanshire",
    "Scotland - Dumfriesshire",
    "Scotland - Dunbartonshire",
    "Scotland - City of Dundee",
    "Scotland - East Lothian",
    "Scotland - City of Edinburgh",
    "Scotland - Fife",
    "Scotland - City of Glasgow",
    "Scotland - Inverness-shire",
    "Scotland - Kincardineshire",
    "Scotland - Kinross-shire",
    "Scotland - Kirkcudbrightshire",
    "Scotland - Lanarkshire",
    "Scotland - Midlothian",
    "Scotland - Moray",
    "Scotland - Nairnshire",
    "Scotland - Orkney",
    "Scotland - Peeblesshire",
    "Scotland - Perthshire",
    "Scotland - Renfrewshire",
    "Scotland - Ross and Cromarty",
    "Scotland - Roxburghshire",
    "Scotland - Selkirkshire",
    "Scotland - Shetland",
    "Scotland - Stirlingshire",
    "Scotland - Sutherland",
    "Scotland - West Lothian",
    "Scotland - Wigtownshire",
    "Wales - Blaenau Gwent",
    "Wales - Bridgend",
    "Wales - Caerphilly",
    "Wales - Carmarthenshire",
    "Wales - Ceredigion",
    "Wales - Swansea",
    "Wales - Cardiff",
    "Wales - Conwy",
    "Wales - Denbighshire",
    "Wales - Flintshire",
    "Wales - Gwynedd",
    "Wales - Isle of Anglesey",
    "Wales - Merthyr Tydfil",
    "Wales - Monmouthshire",
    "Wales - Neath Port Talbot",
    "Wales - Newport",
    "Wales - Pembrokeshire",
    "Wales - Powys",
    "Wales - Rhondda Cynon Taf",
    "Wales - Torfaen",
    "Wales - Vale of Glamorgan",
    "Wales - Wrexham",
  ],
  "United States": ["North America"],
  Uruguay: ["South America"],
  Uzbekistan: ["Asia"],
  Venezuela: ["South America"],
  Vietnam: ["Asia"],
  Yemen: ["Asia"],
  Zambia: ["Africa"],
  Zimbabwe: ["Africa"],
};

// Agents Section Component
const AgentsSection = ({
  searchQuery,
  setSearchQuery,
  selectedCountry,
  setSelectedCountry,
  selectedRegion,
  setSelectedRegion,
  selectedTown,
  setSelectedTown,
  selectedAdminArea,
  setSelectedAdminArea,
  availableCountries,
  availableRegions,
  availableTowns,
  availableAdminAreas,
  filteredAgents,
  isLoadingAgents,
  agentsError,
  searchError,
  fetchSeniorAgentsWithFilters,
  handleFilterChange,
  currentPage,
  totalPages,
  handlePageChange,
  debouncedFetchAgents,
  setCurrentPage,
}) => {
  const agentsListRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [isRegionDropdownOpen, setIsRegionDropdownOpen] = useState(false);
  const [selectedAgentQr, setSelectedAgentQr] = useState(null);

  // Country list
  const countries = Object.keys(regionOptions);

  // Set default values
  const defaultCountry = "United Kingdom";
  const defaultRegion = "England - City of London";

  // Initialize with default values if not provided
  useEffect(() => {
    if (!selectedCountry) {
      setSelectedCountry(defaultCountry);
    }
    if (!selectedRegion) {
      setSelectedRegion(defaultRegion);
    }
  }, []);

  // Handle country change
  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    // Reset region to first available or default for UK
    if (country === "United Kingdom") {
      setSelectedRegion(defaultRegion);
    } else {
      const regions = regionOptions[country] || [];
      setSelectedRegion(regions[0] || "");
    }
    setIsCountryDropdownOpen(false);
  };

  // Handle region change
  const handleRegionChange = (region) => {
    setSelectedRegion(region);
    setIsRegionDropdownOpen(false);
  };

  // Get current regions based on selected country
  const currentRegions = selectedCountry
    ? regionOptions[selectedCountry] || []
    : [];

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="sliding-cards-section py-4 pt-5"
      style={{
        backgroundColor: "#001964",
        marginBottom: "0px",
        borderRadius: "20px",
        padding: "clamp(15px, 4vw, 30px)",
      }}
    >
      <div className="container">
        {/* Header Section */}
        <div style={{ marginBottom: "30px", textAlign: "center" }}>
          <h2
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "clamp(1.2rem, 4vw, 2.2rem)",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              padding: "0 10px",
            }}
          >
            Welcome to TopCoin UK – Where Loyalty Earns Promotional Rewards
          </h2>

          <h2
            className="text-center mb-0"
            style={{
              fontWeight: "bold",
              fontSize: "clamp(1.1rem, 3.5vw, 1.8rem)",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              padding: "0 10px",
            }}
          >
            Sign in as a Customer
          </h2>
          <p
            className="text-center mb-4"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.8rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            (After becoming a customer, you may apply to participate in the
            TopCoin referral programme.)
          </p>
          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.8rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            You may join under an{" "}
            <strong>Authorised Senior Customer Advertising Participants</strong>{" "}
            or a <strong>Company-approved structure </strong> and take part in
            the promotional referral programme.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "clamp(12px, 3vw, 32px)",
              marginBottom: "24px",
              flexWrap: "wrap",
              justifyContent: "center",
              padding: "0 15px",
            }}
          >
            {/* Country Dropdown */}
            <div style={{ position: "relative", minWidth: "200px" }}>
              <button
                onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  padding: "3px 8px",
                  backgroundColor: "transparent",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: "pointer",
                  minWidth: "200px",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  fontWeight: "500",
                  color: "#fff",
                }}
              >
                <span>
                  <FaGlobe style={{ marginRight: "8px", color: "#fff" }} />
                  {selectedCountry || "Select Country"}
                </span>
                <FaChevronDown style={{ fontSize: "12px" }} />
              </button>
              {isCountryDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    marginTop: "4px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    zIndex: 1000,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {countries.map((country) => (
                    <div
                      key={country}
                      onClick={() => handleCountryChange(country)}
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        backgroundColor:
                          selectedCountry === country
                            ? "#f0f0f0"
                            : "transparent",
                        color: "#333",
                        fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        if (selectedCountry !== country) {
                          e.target.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {country}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Region Dropdown */}
            <div style={{ position: "relative", minWidth: "200px" }}>
              <button
                onClick={() => setIsRegionDropdownOpen(!isRegionDropdownOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  padding: "3px 8px",
                  backgroundColor: "transparent",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: "pointer",
                  minWidth: "200px",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  fontWeight: "500",
                  color: "#fff",
                }}
                disabled={!selectedCountry}
              >
                <span>
                  <FaMapMarkerAlt
                    style={{ marginRight: "8px", color: "#fff" }}
                  />
                  {selectedRegion || "Select Region"}
                </span>
                <FaChevronDown style={{ fontSize: "12px" }} />
              </button>
              {isRegionDropdownOpen && currentRegions.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    marginTop: "4px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    zIndex: 1000,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {currentRegions.map((region) => (
                    <div
                      key={region}
                      onClick={() => handleRegionChange(region)}
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        backgroundColor:
                          selectedRegion === region ? "#f0f0f0" : "transparent",
                        color: "#333",
                        fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        if (selectedRegion !== region) {
                          e.target.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {region}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "clamp(12px, 3vw, 32px)",
              marginBottom: "24px",
              flexWrap: "wrap",
              justifyContent: "center",
              padding: "0 15px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <a
                href="/customer-senior-mini-agents"
                style={{
                  backgroundColor: "transparent",
                  color: "#ffffff",
                  padding: "8px 24px",
                  borderRadius: "4px",
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  border: "1px solid rgba(255,255,255,0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.3s ease",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255,255,255,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                }}
              >
                🌍 View All Senior & Mini Agent Network
                <FaArrowRight size={14} />
              </a>
            </div>
          </div>
        </div>

        {/* Find an Agent Section */}
        <div
          className="AgentLists"
          style={{
            backgroundColor: "#ebeef7",
            padding: "clamp(20px, 4vw, 30px)",
            marginLeft: "-15px",
            marginRight: "-15px",
            width: "calc(100% + 30px)",
            position: "relative",
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            width: "100vw",
            maxWidth: "none",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              padding: "0 15px",
            }}
          >
            {/* Find an Agent Section */}
            <div style={{ marginBottom: "40px" }}>
              <h3
                style={{
                  fontSize: "clamp(1.1rem, 3vw, 1.5rem)",
                  fontWeight: "700",
                  color: "#001964",
                  marginBottom: "8px",
                  textAlign: "center",
                }}
              >
                Find a Customer Agent
              </h3>
              <p
                style={{
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  color: "#666666",
                  marginBottom: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                Search by name, ID, country, region, or town.
              </p>

              {/* Search Bar - Full width on mobile */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  marginBottom: "20px",
                  padding: isMobile ? "0 10px" : "0",
                }}
              >
                <form
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "white",
                    border: "1px solid #d0d0d0",
                    borderRadius: "32px",
                    width: "100%",
                    maxWidth: isMobile ? "100%" : "500px",
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    fetchSeniorAgentsWithFilters(1, {
                      searchQuery,
                      selectedCountry,
                      selectedRegion,
                      selectedTown,
                      selectedAdminArea,
                    });
                    setCurrentPage(1);
                  }}
                >
                  <span style={{ padding: "0 12px", color: "#666" }}>
                    <FaSearch size={isMobile ? 14 : 16} />
                  </span>
                  <input
                    type="text"
                    placeholder={
                      isMobile
                        ? "Search agents by name, ID, country, region, or town..."
                        : "Search agents by name, ID, country, region, or town..."
                    }
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      flex: 1,
                      border: "none",
                      outline: "none",
                      fontSize: isMobile ? "8px" : "14px",
                      color: "#333",
                      backgroundColor: "transparent",
                      padding: isMobile ? "10px 0" : "12px 0",
                      minHeight: isMobile ? "40px" : "auto",
                    }}
                   maxLength={20} />
                  {searchQuery && (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchQuery("");
                        fetchSeniorAgentsWithFilters(1, {
                          searchQuery: "",
                          selectedCountry,
                          selectedRegion,
                          selectedTown,
                          selectedAdminArea,
                        });
                        setCurrentPage(1);
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: "0 8px",
                        color: "#666",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                      title="Clear search"
                    >
                      <FaTimes size={isMobile ? 14 : 16} />
                    </button>
                  )}
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#2D4CA8",
                      color: "white",
                      border: "none",
                      borderRadius: "0 32px 32px 0",
                      padding: isMobile ? "10px 16px" : "12px 24px",
                      marginLeft: "8px",
                      fontWeight: "bold",
                      fontSize: isMobile ? "13px" : "14px",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      minHeight: isMobile ? "40px" : "auto",
                    }}
                  >
                    {isMobile ? "Search" : "Search"}
                  </button>
                </form>
              </div>

              {/* Filter Dropdowns - Stack vertically on mobile */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginBottom: "16px",
                  justifyContent: "center",
                  flexDirection: isMobile ? "column" : "row",
                  padding: isMobile ? "0 10px" : "0",
                }}
              >
                {/* Country Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedCountry || "United Kingdom"}
                    onChange={(e) =>
                      handleFilterChange("country", e.target.value)
                    }
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 5px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Country</option>
                    {/* Include all countries from regionOptions */}
                    {Object.keys(regionOptions).map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                    {/* Add any additional countries from availableCountries that aren't in regionOptions */}
                    {availableCountries
                      .filter(
                        (country) =>
                          !Object.keys(regionOptions).includes(country),
                      )
                      .map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>

                {/* Admin Area Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedAdminArea}
                    onChange={(e) =>
                      handleFilterChange("adminArea", e.target.value)
                    }
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 14px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Admin Area</option>
                    {availableAdminAreas.map((area) => (
                      <option key={area} value={area}>
                        {area}
                      </option>
                    ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>

                {/* Town Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedTown}
                    onChange={(e) => handleFilterChange("town", e.target.value)}
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 14px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Town</option>
                    {availableTowns.map((town) => (
                      <option key={town} value={town}>
                        {town}
                      </option>
                    ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>

              {searchError && (
                <div
                  style={{
                    color: "#ff6b6b",
                    fontSize: isMobile ? "13px" : "14px",
                    marginTop: "8px",
                    textAlign: "center",
                    padding: "0 10px",
                  }}
                >
                  {searchError}
                </div>
              )}
            </div>

            {/* Available Senior Agents Section */}
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "4px",
                  flexWrap: "wrap",
                }}
              >
                <h3
                  style={{
                    fontSize: "clamp(1rem, 2.8vw, 1.3rem)",
                    fontWeight: "600",
                    color: "#001964",
                    margin: 0,
                  }}
                >
                  Available Senior Agents
                </h3>
              </div>

              <p
                style={{
                  fontSize: isMobile ? "13px" : "clamp(0.9rem, 2.5vw, 1rem)",
                  color: "#001964",
                  marginBottom: "15px",
                }}
              >
                Choose an agent to join under.
              </p>
            </div>

            {/* Agents List with Scrollbar */}
            <div
              ref={agentsListRef}
              style={{
                maxHeight: isMobile ? "500px" : "600px",
                overflowY: "auto",
                paddingRight: isMobile ? "5px" : "10px",
                marginRight: isMobile ? "-5px" : "-10px",
                scrollbarWidth: "thin",
                scrollbarColor: "#2D4CA8 #e0e0e0",
              }}
              className="agents-scrollable-list"
            >
              {isLoadingAgents ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <div
                    className="spinner-border"
                    style={{ color: "#2D4CA8" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading agents...</span>
                  </div>
                </div>
              ) : agentsError ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#ff6b6b",
                  }}
                >
                  {agentsError}
                </div>
              ) : (
                <div>
                  {filteredAgents.map((agent, index) => (
                    <div
                      key={agent.id || index}
                      style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: isMobile ? "12px" : "16px",
                        marginBottom: "12px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                      className="agent-card"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: isMobile ? "12px" : "16px",
                        }}
                      >
                        {/* Profile Picture */}
                        <div
                          style={{
                            width: isMobile ? "40px" : "50px",
                            height: isMobile ? "40px" : "50px",
                            backgroundColor: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            overflow: "hidden",
                            marginBottom: isMobile ? "4px" : "0",
                            cursor: "pointer",
                          }}
                          onClick={() => setSelectedAgentQr(agent)}
                        >
                          <QRCode
                            value={`${window.location.origin}/create-account?ref=${agent.agent_code}${selectedCountry ? `&country=${encodeURIComponent(selectedCountry)}` : ""}`}
                            size={isMobile ? 40 : 50}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                          />
                        </div>

                        {/* Agent Details */}
                        <div style={{ flex: 1, width: "100%" }}>
                          {/* First Row: Name with number */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: isMobile
                                    ? "14px"
                                    : "clamp(1rem, 2.5vw, 1.1rem)",
                                  fontWeight: "600",
                                  color: "#001964",
                                  margin: 0,
                                }}
                              >
                                S{agent.id + 99}
                              </h4>
                            </div>
                          </div>

                          {/* Second Row: Senior Agent text */}
                          <div
                            style={{
                              fontSize: isMobile
                                ? "12px"
                                : "clamp(0.85rem, 2vw, 0.95rem)",
                              color: "#666",
                              marginBottom: "0px",
                              textAlign: "left",
                            }}
                          >
                            Senior Customer Ads Agent
                          </div>

                          {/* Stats */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <span
                              style={{
                                fontSize: isMobile
                                  ? "12px"
                                  : "clamp(0.85rem, 2vw, 0.95rem)",
                                color: "#001964",
                                fontWeight: "500",
                              }}
                            >
                              {agent.agents_count ?? 0}{" "}
                              {(agent.agents_count ?? 0) !== 1
                                ? "Agents"
                                : "Agent"}
                              {" · "}
                              {agent.customers_count ?? 0}{" "}
                              {(agent.customers_count ?? 0) !== 1
                                ? "Customers"
                                : "Customer"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                          width: "100%",
                          justifyContent: isMobile
                            ? "space-between"
                            : "flex-end",
                          marginBottom: "12px",
                        }}
                      >
                        <a
                          href={`/customer-senior-mini-agents`}
                          style={{
                            color: "#333",
                            textDecoration: "none",
                            fontSize: isMobile
                              ? "12px"
                              : "clamp(0.8rem, 2vw, 0.9rem)",
                            fontWeight: "500",
                            border: "1px solid #d0d0d0",
                            padding: isMobile ? "8px 12px" : "6px 16px",
                            borderRadius: "4px",
                            transition: "all 0.2s ease",
                            whiteSpace: "nowrap",
                            flex: isMobile ? "1" : "none",
                            textAlign: "center",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f5f5f5";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                        >
                          View Details
                        </a>
                        <a
                          href={`/create-account?ref=${agent.agent_code}${selectedCountry ? `&country=${encodeURIComponent(selectedCountry)}` : ""}`}
                          style={{
                            backgroundColor: "#223e9a",
                            color: "white",
                            padding: isMobile ? "8px 12px" : "6px 16px",
                            borderRadius: "4px",
                            textDecoration: "none",
                            fontSize: isMobile
                              ? "12px"
                              : "clamp(0.8rem, 2vw, 0.9rem)",
                            fontWeight: "500",
                            display: "inline-block",
                            transition: "all 0.2s ease",
                            whiteSpace: "nowrap",
                            flex: isMobile ? "1" : "none",
                            textAlign: "center",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#1a3a8f";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#223e9a";
                          }}
                        >
                          Join Under
                        </a>
                      </div>

                      {/* Divider */}
                      <div>
                        <hr
                          style={{
                            borderColor: "#e0e0e0",
                            margin: isMobile ? "8px 0" : "12px 0",
                          }}
                        />
                      </div>

                      {/* Coverage Area */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: isMobile
                            ? "11px"
                            : "clamp(0.8rem, 2vw, 0.9rem)",
                          color: "#001964",
                          flexWrap: "wrap",
                        }}
                      >
                        <FaMapMarkerAlt
                          color="#2D4CA8"
                          size={isMobile ? 10 : 12}
                        />
                        <span>
                          <strong>Coverage:</strong>{" "}
                          {agent.coverage_areas?.length > 0
                            ? agent.coverage_areas.join(", ").length >
                              (isMobile ? 30 : 50)
                              ? `${agent.coverage_areas.join(", ").substring(0, isMobile ? 30 : 50)}...`
                              : agent.coverage_areas.join(", ")
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  ))}

                  {filteredAgents.length === 0 && !isLoadingAgents && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: isMobile ? "30px" : "40px",
                        backgroundColor: "#ffffff",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: "#666666",
                      }}
                    >
                      <p
                        style={{
                          marginBottom: "16px",
                          fontSize: isMobile ? "14px" : "14px",
                        }}
                      >
                        No agents found matching your criteria.
                      </p>
                      <button
                        onClick={() => {
                          setSearchQuery("");
                          setSelectedCountry("");
                          setSelectedRegion("");
                          setSelectedTown("");
                          setSelectedAdminArea("");
                          fetchSeniorAgentsWithFilters(1, {
                            searchQuery: "",
                            selectedCountry: "",
                            selectedRegion: "",
                            selectedTown: "",
                            selectedAdminArea: "",
                          });
                        }}
                        style={{
                          backgroundColor: "transparent",
                          color: "#4CAF50",
                          border: "1px solid #4CAF50",
                          borderRadius: "20px",
                          padding: "8px 20px",
                          fontSize: "0.95rem",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#4CAF50";
                          e.target.style.color = "white";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#4CAF50";
                        }}
                      >
                        Show All Agents
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>


          </div>
        </div>
      </div>

      {/* QR Code Modal */}
      {selectedAgentQr && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setSelectedAgentQr(null)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              position: "relative",
              maxWidth: "90%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedAgentQr(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              <FaTimes />
            </button>
            <h4 style={{ marginBottom: "20px", color: "#001964", marginTop: "10px" }}>
              Join under S{selectedAgentQr.id + 99}
            </h4>
            <div style={{ background: "white", padding: "16px", borderRadius: "8px", display: "inline-block" }}>
              <QRCode
                value={`${window.location.origin}/create-account?ref=${selectedAgentQr.agent_code}${selectedCountry ? `&country=${encodeURIComponent(selectedCountry)}` : ""}`}
                size={200}
              />
            </div>
            <p style={{ marginTop: "20px", color: "#666", fontSize: "14px" }}>
              Scan this QR code to join under this agent
            </p>
          </div>
        </div>
      )}

      <style>
        {`
          .agents-scrollable-list::-webkit-scrollbar {
            width: 8px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-track {
            background: #e0e0e0;
            border-radius: 10px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-thumb {
            background: #2D4CA8;
            border-radius: 10px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-thumb:hover {
            background: #1a3a8f;
          }
          
          @media (max-width: 768px) {
            .agents-scrollable-list {
              max-height: 500px;
            }
            
            .agent-card {
              padding: 12px !important;
            }
            
            .agent-card h4 {
              font-size: 14px !important;
            }
            
            .agent-card .btn {
              font-size: 12px !important;
              padding: 8px 12px !important;
            }
            
            select {
              font-size: 14px !important;
              min-height: 48px !important;
            }
            
            input {
              font-size: 14px !important;
            }
            
            button {
              font-size: 13px !important;
            }
          }

          /* iOS specific fixes */
          @supports (-webkit-touch-callout: none) {
            select, input, button {
              -webkit-appearance: none;
              border-radius: 8px;
            }
            
            select {
              background-image: none;
            }
            
            input[type="text"],
            select {
              font-size: 16px !important;
            }
          }

          /* Android specific fixes */
          @media (max-width: 768px) {
            select, input, button {
              touch-action: manipulation;
            }
          }
        `}
      </style>
    </div>
  );
};

// Success Message Component
const SuccessMessage = ({
  message,
  loginData,
  handleDismissMessage,
  openInNewTab,
  setMessage,
  clearMessageAfterDelay,
}) => {
  if (message.type !== "success") return null;

  const handleOpenWallet = () => {
    if (loginData && loginData.access_token) {
      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, loginData.access_token);
      const walletUrl = `${window.location.origin}/customer/wallet`;
      openInNewTab(walletUrl);
    } else {
      const authToken = localStorage.getItem("auth_token");
      if (authToken) {
        const tempTokenKey = `customer_temp_token_${Date.now()}`;
        localStorage.setItem(tempTokenKey, authToken);
        const walletUrl = `${window.location.origin}/customer/wallet`;
        openInNewTab(walletUrl);
      } else {
        setMessage({
          text: "Please login again to access your wallet.",
          type: "error",
        });
        clearMessageAfterDelay(5000);
      }
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "10px",
        borderRadius: "8px",
        margin: "10px 0",
        fontWeight: "500",
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        border: "1px solid #c8e6c9",
      }}
    >
      <p
        style={{ margin: "0 0 10px 0", fontSize: "clamp(0.8rem, 2vw, 0.9rem)" }}
      >
        {message.text}
        <button
          onClick={handleDismissMessage}
          style={{
            background: "none",
            border: "none",
            color: "inherit",
            marginLeft: "10px",
            cursor: "pointer",
            float: "right",
            fontSize: "16px",
          }}
          title="Dismiss message"
        >
          ×
        </button>
      </p>
      <button
        onClick={handleOpenWallet}
        style={{
          backgroundColor: "#2D4CA8",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
          marginTop: "5px",
        }}
      >
        Open Customer Wallet in New Tab
      </button>
    </div>
  );
};

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [captchaToken, setCaptchaToken] = useState(null);

  // State for referral code
  const [referralCode, setReferralCode] = useState(null);
  // State for login data
  const [loginData, setLoginData] = useState(null);
  // Ref for auto-dismiss timeout
  const autoDismissRef = useRef(null);

  // Senior Agents with Mini Agents state
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState(true);
  const [agentsError, setAgentsError] = useState(null);
  const searchInputRef = useRef(null);

  // Filter states
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedTown, setSelectedTown] = useState("");
  const [selectedAdminArea, setSelectedAdminArea] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchError, setSearchError] = useState("");

  // Available options for filters
  const [availableCountries, setAvailableCountries] = useState([]);
  const [availableRegions, setAvailableRegions] = useState([]);
  const [availableTowns, setAvailableTowns] = useState([]);
  const [availableAdminAreas, setAvailableAdminAreas] = useState([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAgents, setTotalAgents] = useState(0);

  // Create debounced search function
  const debouncedFetchAgents = useRef(
    debounce((page, filters) => {
      fetchSeniorAgentsWithFilters(page, filters);
    }, 500),
  ).current;

  // Initialize referral code from URL or localStorage
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlRef = params.get("ref");

    if (urlRef) {
      localStorage.setItem("login_referral_code", urlRef);
      setReferralCode(urlRef);
    } else {
      const storedRef = localStorage.getItem("login_referral_code");
      if (storedRef) {
        setReferralCode(storedRef);
      }
    }
  }, []);

  // Fetch senior agents with their mini agents
  const fetchSeniorAgentsWithFilters = useCallback(
    async (page = 1, filters = {}) => {
      try {
        setIsLoadingAgents(true);
        setAgentsError(null);

        // Build query parameters
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("per_page", "50");

        // Add search if it has value
        if (filters.searchQuery && filters.searchQuery.trim()) {
          let query = filters.searchQuery.trim();
          
          // Handle 'S' prefix search (e.g., S101 -> ID 2)
          const sMatch = query.toUpperCase().match(/^S(\d+)$/);
          if (sMatch) {
            const agentId = parseInt(sMatch[1], 10) - 99;
            if (!isNaN(agentId) && agentId > 0) {
              query = agentId.toString();
            }
          }
          
          params.append("search", query);
        }

        // Add filters if they have values
        if (filters.selectedCountry && filters.selectedCountry.trim()) {
          params.append("country", filters.selectedCountry);
        }
        if (filters.selectedRegion && filters.selectedRegion.trim()) {
          params.append("region", filters.selectedRegion);
        }
        if (filters.selectedTown && filters.selectedTown.trim()) {
          params.append("town", filters.selectedTown);
        }
        if (filters.selectedAdminArea && filters.selectedAdminArea.trim()) {
          params.append("admin_area", filters.selectedAdminArea);
        }

        const queryString = params.toString();
        const url = `${API_URL}/api/public/senior-agents-with-mini${queryString ? "?" + queryString : ""}`;

        console.log("Fetching URL:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Received data:", data);

        if (data.success) {
          // Update filter options from response
          setAvailableCountries(data.filters?.available_countries || []);
          setAvailableRegions(data.filters?.available_regions || []);
          setAvailableTowns(data.filters?.available_towns || []);
          setAvailableAdminAreas(data.filters?.available_admin_areas || []);

          // Sort agents to ensure TCUK Customer Master Charity appears first
          const sortedAgents = (data.senior_agents || []).sort((a, b) => {
            // Check if name contains "TCUK Customer Master Charity"
            const aIsSpecial =
              a.name && a.name.includes("TCUK Customer Master Charity");
            const bIsSpecial =
              b.name && b.name.includes("TCUK Customer Master Charity");

            if (aIsSpecial && !bIsSpecial) return -1;
            if (!aIsSpecial && bIsSpecial) return 1;
            return 0;
          });

          setSeniorAgents(sortedAgents);
          setFilteredAgents(sortedAgents);

          // Update pagination
          setCurrentPage(data.pagination?.current_page || 1);
          setTotalPages(data.pagination?.last_page || 1);
          setTotalAgents(data.pagination?.total || 0);
        } else {
          throw new Error(data.message || "Failed to fetch agents");
        }
      } catch (error) {
        console.error("Failed to fetch senior agents:", error);
        setAgentsError(
          "Failed to load senior agents. Showing sample data instead.",
        );

        // Fallback data with TCUK Customer Master Charity first
        const fallbackData = [
          {
            id: 2,
            name: "TCUK Customer Master Charity",
            isVerified: true,
            focus_countries: ["United Kingdom"],
            mini_agents_count: 4,
            agents_count: 4,
            customers_count: 0,
            coverage_areas: ["London", "Manchester", "Birmingham", "Leeds"],
            agent_code: "TCUK001",
            profile_photo: null,
          },
          {
            id: 1,
            name: "Erambaamoorthy ILAMURUGAN",
            isVerified: true,
            focus_countries: ["United Kingdom"],
            mini_agents_count: 2,
            agents_count: 2,
            customers_count: 0,
            coverage_areas: ["Area 1 – North London"],
            agent_code: "PB0VADQC",
            profile_photo: null,
          },
        ];

        setSeniorAgents(fallbackData);
        setFilteredAgents(fallbackData);
        setAvailableCountries(["United Kingdom"]);
        setAvailableRegions(["South East", "North West", "Midlands"]);
        setAvailableTowns(["Town1", "Town2", "Town3", "Town4"]);
        setAvailableAdminAreas(["Area 1 – North London"]);
      } finally {
        setIsLoadingAgents(false);
      }
    },
    [],
  );

  // Initial load - fetch first page
  useEffect(() => {
    fetchSeniorAgentsWithFilters(1, {
      searchQuery: "",
      selectedCountry: "",
      selectedRegion: "",
      selectedTown: "",
      selectedAdminArea: "",
    });
  }, []); // Empty dependency array for initial load only

  // Handle filter change - real-time updates
  const handleFilterChange = (filterType, value) => {
    let newSelectedCountry = selectedCountry;
    let newSelectedRegion = selectedRegion;
    let newSelectedTown = selectedTown;
    let newSelectedAdminArea = selectedAdminArea;

    switch (filterType) {
      case "country":
        newSelectedCountry = value;
        // Reset dependent filters when country changes
        newSelectedRegion = "";
        newSelectedTown = "";
        newSelectedAdminArea = "";
        setSelectedRegion("");
        setSelectedTown("");
        setSelectedAdminArea("");
        break;
      case "region":
        newSelectedRegion = value;
        // Reset town and admin area when region changes (optional)
        newSelectedTown = "";
        newSelectedAdminArea = "";
        setSelectedTown("");
        setSelectedAdminArea("");
        break;
      case "town":
        newSelectedTown = value;
        break;
      case "adminArea":
        newSelectedAdminArea = value;
        break;
      default:
        break;
    }

    setSelectedCountry(newSelectedCountry);
    setSelectedRegion(newSelectedRegion);
    setSelectedTown(newSelectedTown);
    setSelectedAdminArea(newSelectedAdminArea);
    setCurrentPage(1); // Reset to first page

    // Build filters object with only non-empty values
    const filters = {};
    if (newSelectedCountry && newSelectedCountry.trim()) {
      filters.selectedCountry = newSelectedCountry;
    }
    if (newSelectedRegion && newSelectedRegion.trim()) {
      filters.selectedRegion = newSelectedRegion;
    }
    if (newSelectedTown && newSelectedTown.trim()) {
      filters.selectedTown = newSelectedTown;
    }
    if (newSelectedAdminArea && newSelectedAdminArea.trim()) {
      filters.selectedAdminArea = newSelectedAdminArea;
    }
    if (searchQuery && searchQuery.trim()) {
      filters.searchQuery = searchQuery;
    }

    // Debounce the API call with only the active filters
    debouncedFetchAgents(1, filters);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      fetchSeniorAgentsWithFilters(newPage, {
        searchQuery,
        selectedCountry,
        selectedRegion,
        selectedTown,
        selectedAdminArea,
      });
    }
  };

  // Handle Enter key in search input (optional - can be removed if not needed)
  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      // Cancel any pending debounced calls and fetch immediately
      debouncedFetchAgents.cancel();
      fetchSeniorAgentsWithFilters(1, {
        searchQuery,
        selectedCountry,
        selectedRegion,
        selectedTown,
        selectedAdminArea,
      });
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedFetchAgents.cancel();
    };
  }, [debouncedFetchAgents]);

  // captcha handler
  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const validateLoginForm = () => {
    if (!email.trim()) {
      setMessage({ text: "Email is required.", type: "error" });
      return false;
    }

    if (email.length > 255) {
      setMessage({
        text: "Please enter a valid email address.",
        type: "error",
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({
        text: "Please enter a valid email address.",
        type: "error",
      });
      return false;
    }

    if (!password) {
      setMessage({ text: "Password is required.", type: "error" });
      return false;
    }

    if (password.length < 8) {
      setMessage({ text: "Email or Password incorrect.", type: "error" });
      return false;
    }

    if (password.length > 50) {
      setMessage({ text: "Email or Password incorrect.", type: "error" });
      return false;
    }

    if (!captchaToken) {
      setMessage({ text: "Captcha verification is required.", type: "error" });
      return false;
    }

    return true;
  };

  const handleGoogleLogin = () => {
    const callbackUrl = `${window.location.origin}/auth/google/callback`;
    let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(callbackUrl)}`;

    if (referralCode) {
      googleAuthUrl += `&ref=${encodeURIComponent(referralCode)}`;
      localStorage.setItem("pending_oauth_referral", referralCode);
    }

    sessionStorage.setItem("just_logged_in", "true");
    localStorage.setItem("just_logged_in_timestamp", Date.now().toString());
    window.location.href = googleAuthUrl;
  };

  const handleAppleLogin = () => {
    window.open(`${API_URL}/api/auth/apple`, "_blank");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateLoginForm()) return;

    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/customer/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
          referral_code: referralCode || null,
          "g-recaptcha-response": captchaToken,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage({
          text: data.message || "Login failed. Please check your credentials.",
          type: "error",
        });
        clearMessageAfterDelay(10000);
        setIsLoading(false);
        return;
      }

      // Login successful
      localStorage.setItem("auth_token", data.access_token);
      setLoginData(data);

      localStorage.setItem(
        "user",
        JSON.stringify(
          data.user || {
            name: data.user?.name || email.split("@")[0],
            email: email,
          },
        ),
      );

      sessionStorage.setItem("just_logged_in", "true");
      localStorage.setItem("just_logged_in_timestamp", Date.now().toString());
      localStorage.setItem("is_first_login", "false");
      localStorage.removeItem("login_referral_code");

      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });

      clearMessageAfterDelay(15000);
      clearFormFields();

      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, data.access_token);

      const walletUrl = `${window.location.origin}/customer/wallet`;
      const isPopup = window.opener || window.parent !== window;

      if (isPopup) {
        window.location.href = walletUrl;
      } else {
        const newWindow = openInNewTab(walletUrl);

        setTimeout(() => {
          try {
            if (newWindow && newWindow.postMessage) {
              newWindow.postMessage(
                {
                  type: "LOGIN_SUCCESS",
                  token: data.access_token,
                  tempTokenKey: tempTokenKey,
                },
                window.location.origin,
              );
            }
          } catch (e) {
            console.log("Could not send message to wallet tab:", e);
          }

          setTimeout(() => {
            localStorage.removeItem(tempTokenKey);
          }, 30000);
        }, 500);
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage({
        text: "Network error. Please check your connection and try again.",
        type: "error",
      });
      clearMessageAfterDelay(10000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key && e.key.startsWith("customer_temp_token_")) {
        const token = localStorage.getItem(e.key);
        if (token) {
          localStorage.setItem("auth_token", token);
          if (window.location.pathname.includes("/login")) {
            navigate("/customer/wallet");
          }
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data && event.data.type === "LOGIN_SUCCESS") {
        localStorage.setItem("auth_token", event.data.token);
        if (event.data.tempTokenKey) {
          localStorage.removeItem(event.data.tempTokenKey);
        }
        navigate("/customer/wallet");
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  const openInNewTab = (url) => {
    try {
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");

      if (newWindow) {
        return newWindow;
      }

      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return { closed: true };
    } catch (error) {
      console.error("Error opening new tab:", error);
      window.location.href = url;
      return { closed: true };
    }
  };

  const clearFormFields = () => {
    setEmail("");
    setPassword("");
    setPasswordVisible(false);
  };

  const handleDismissMessage = () => {
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }
    setMessage({ text: "", type: "" });
    setLoginData(null);
  };

  const clearMessageAfterDelay = (delay = 10000) => {
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
    }

    autoDismissRef.current = setTimeout(() => {
      setMessage({ text: "", type: "" });
      setLoginData(null);
    }, delay);
  };

  useEffect(() => {
    if (location.hash === "#customer-login") {
      const el = document.getElementById("customer-login");
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const name = params.get("name");
    const email = params.get("email");
    const firstLogin = params.get("firstLogin") === "true";

    if (token) {
      localStorage.setItem("auth_token", token);
      localStorage.setItem("user_name", name || "");
      localStorage.setItem("user_email", email || "");
      localStorage.setItem("is_first_login", firstLogin ? "true" : "false");

      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });
      setLoginData({ access_token: token });
      clearMessageAfterDelay(15000);

      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  return (
    <Fragment>
      <div
        className="index_ico page_wrapper"
        style={{
          backgroundColor: "#001964",
          color: "#fff",
        }}
      >
        <Header />
        <main className="page_content">
          {/* Agents Section */}
          <AgentsSection
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion}
            selectedTown={selectedTown}
            setSelectedTown={setSelectedTown}
            selectedAdminArea={selectedAdminArea}
            setSelectedAdminArea={setSelectedAdminArea}
            availableCountries={availableCountries}
            availableRegions={availableRegions}
            availableTowns={availableTowns}
            availableAdminAreas={availableAdminAreas}
            filteredAgents={filteredAgents}
            isLoadingAgents={isLoadingAgents}
            agentsError={agentsError}
            searchError={searchError}
            fetchSeniorAgentsWithFilters={fetchSeniorAgentsWithFilters}
            handleFilterChange={handleFilterChange}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            debouncedFetchAgents={debouncedFetchAgents}
            setCurrentPage={setCurrentPage}
          />

          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            When someone joins TopCoin UK, they receive a personal ID (QR code)
            which allows them to participate in our customer referral and
            loyalty programme. TopCoin UK promotes participating businesses and
            helps customers discover them through structured advertising and
            referral activity.
          </p>

          <h4
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              padding: "0 15px",
            }}
          >
            How Do TopCoin Agents Receive Free TopCoin?
          </h4>
          <p
            className="text-center mb-3"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            As a <strong>TopCoin UK participant</strong>, you may receive free
            TopCoin when you introduce someone to a participating business.
          </p>
          <div
            className="text-center "
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            <ul
              className="text-center mb-4"
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
                maxWidth: "800px",
                margin: "0 auto",
                lineHeight: "1.6",
                listStylePosition: "inside",
                paddingLeft: 0,
                display: "inline-block",
                textAlign: "left",
              }}
            >
              <li>When a person you introduce makes a qualifying purchase,</li>
              <li>
                You receive the<strong> same number of TopCoin</strong> they
                receive, in accordance with programme rules.
              </li>
            </ul>
          </div>
          <p
            className="text-center mb-3"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            TopCoin is provided <strong>free of charge </strong>as part of the
            TopCoin UK promotional loyalty programme.
          </p>
          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            Encourage others to discover participating businesses and take part
            in everyday loyalty rewards.
          </p>
          <section
            className="register_section section_decoration py-5"
            style={{ minHeight: "0px" }}
          >
            <div className="container">
              <div className="row justify-content-center">
                {/* CENTERED LOGIN BOX */}
                <div
                  className="col-lg-4 col-md-8 col-sm-10"
                  id="customer-login"
                >
                  <div
                    className="bg-white text-center shadow p-4 margin-top-lg mx-auto"
                    style={{
                      color: "#000",
                      borderRadius: "20px",
                      maxWidth: "500px",
                      marginTop: "0px",
                      marginBottom: "40px",
                      padding: "clamp(20px, 4vw, 30px)",
                    }}
                  >
                    <div className="d-flex justify-content-center mb-0">
                      <img
                        src={coinIcon}
                        alt="TopCoin UK"
                        style={{
                          width: "clamp(80px, 15vw, 115px)",
                          height: "clamp(80px, 15vw, 115px)",
                        }}
                      />
                    </div>

                    <h4
                      className="fw-bold mb-1"
                      style={{
                        background:
                          "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        display: "inline-block",
                        fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
                      }}
                    >
                      Customer / Customer Agent - SIGN IN
                    </h4>
                    <h3
                      className="sub-title mb-2"
                      style={{ fontSize: "clamp(0.9rem, 2.5vw, 1rem)" }}
                    >
                      Enter your Email and Password
                    </h3>

                    {/* Success Message with Wallet Button */}
                    <SuccessMessage
                      message={message}
                      loginData={loginData}
                      handleDismissMessage={handleDismissMessage}
                      openInNewTab={openInNewTab}
                    />

                    {/* Regular Message display */}
                    {message.text && message.type !== "success" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "7px 10px",
                          borderRadius: "8px",
                          margin: "10px 0",
                          fontWeight: "500",
                          fontSize: "0.9rem",
                          backgroundColor:
                            message.type === "error" ? "#ffebee" : "#e8f5e9",
                          color:
                            message.type === "error" ? "#c62828" : "#2e7d32",
                          border:
                            message.type === "error"
                              ? "1px solid #ffcdd2"
                              : "1px solid #c8e6c9",
                        }}
                      >
                        <div style={{ flex: 1, textAlign: "center" }}>
                          {message.text}
                        </div>
                        <button
                          onClick={handleDismissMessage}
                          style={{
                            background: "none",
                            border: "none",
                            color: "inherit",
                            cursor: "pointer",
                            fontSize: "18px",
                            padding: "0",
                            lineHeight: "1",
                            marginLeft: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Dismiss message"
                        >
                          &times;
                        </button>
                      </div>
                    )}

                    {/* Login Form */}
                    <form onSubmit={handleLogin} className="text-start mb-4">
                      <div className="mb-1">
                        <label
                          className="form-label fw-semibold mb-0"
                          style={{
                            color: "#052C65",
                            fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                          }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          maxLength={255}
                          className="form-control bg-white"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={isLoading}
                          style={{
                            borderRadius: "8px",
                            padding: "12px",
                            border: "1px solid #ccc",
                            color: "black",
                            fontSize: "16px",
                          }}
                        />
                      </div>

                      <div className="mb-0 position-relative">
                        <label
                          className="form-label fw-semibold mb-0"
                          style={{
                            color: "#052C65",
                            fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                          }}
                        >
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            maxLength={255}
                            className="form-control bg-white"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            style={{
                              borderRadius: "8px",
                              padding: "12px",
                              border: "1px solid #ccc",
                              color: "black",
                              paddingRight: "40px",
                              fontSize: "16px",
                            }}
                          />
                          <span
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "12px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#666",
                              zIndex: 2,
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {passwordVisible ? (
                              <FaEye size={18} />
                            ) : (
                              <FaEyeSlash size={18} />
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Forgot Password Link */}
                      <div className="mb-2 text-end">
                        <a
                          href="/forgot-password"
                          style={{
                            color: "#2D4CA8",
                            fontWeight: "500",
                            textDecoration: "none",
                            fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                          }}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      {/* reCAPTCHA */}
                      <div
                        style={{
                          marginBottom: "16px",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          transform: "scale(0.77)",
                          transformOrigin: "center",
                        }}
                      >
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                          onChange={onCaptchaChange}
                        />
                      </div>

                      <button
                        type="submit"
                        className="w-100 text-white fw-bold py-2"
                        disabled={isLoading}
                        style={{
                          backgroundColor: isLoading ? "#666" : "#0000A0",
                          borderRadius: "8px",
                          border: "none",
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                          padding: "12px",
                          fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                        }}
                      >
                        {isLoading ? "Logging in..." : "SIGN IN"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
          
          .agent-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.3) !important;
          }
          
          .agent-preview {
            animation: fadeIn 0.2s ease;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
          }
          
          iframe[title="reCAPTCHA"] {
            min-height: 100px !important;
          }

          @media (max-width: 768px) {
            .agent-preview {
              -webkit-backdrop-filter: blur(5px);
              backdrop-filter: blur(5px);
            }
            
            h1 { font-size: 28px !important; }
            h2 { font-size: 20px !important; }
            
            select.form-select, 
            input.form-control,
            button {
              font-size: 16px !important;
              min-height: 48px;
            }
            
            .react-tel-input .form-control {
              font-size: 16px !important;
            }
            
            .agents-scrollable-list {
              max-height: 450px;
            }
          }
          
          select.form-select, input.form-control {
            background-color: rgba(255,255,255,0.95);
            color: #333;
          }
          
          select.form-select option {
            background-color: white;
            color: #333;
          }
          
          select.form-select:focus, input.form-control:focus {
            box-shadow: 0 0 0 3px rgba(45, 76, 168, 0.3);
            border-color: #2D4CA8;
          }

          /* iOS specific fixes */
          @supports (-webkit-touch-callout: none) {
            input, select, textarea, button {
              -webkit-appearance: none;
              border-radius: 8px;
            }
            
            button[type="submit"] {
              -webkit-appearance: none;
              touch-action: manipulation;
            }
            
            input[type="text"],
            input[type="email"],
            input[type="password"],
            select,
            textarea {
              font-size: 16px !important;
            }
          }
        `}
      </style>
    </Fragment>
  );
}

export default LoginPage;
